import { IoPulseOutline } from "react-icons/io5";

const Loader = () => {
  return (
    <div className="w-full h-full fixed top-0 left-0 opacity-80 z-50 bg-black">
      <div className="flex h-screen relative">
        <div className="m-auto">
          <span className="text-blue-500 opacity-100">
            <IoPulseOutline className="animate-pulse text-8xl" />
          </span>
          <p className="text-white text-xl mt-5 text-center animate-pulse">
            Loading . . .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
